import { ComponentHelper } from "../core/util/componentHelper";
import { Config } from "../core/config/config";
import { Grid } from "../core/components/grid";
import { HTTPService } from "../core/util/httpManager";
import { Dialog, DialogProps } from "../core/components/dialog";
import { FieldInstance } from "../core/components/field";
import { MultiSelect } from "../core/components/multiSelect";
import { ToolBar } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import React from "react"

export default class AffilationsGrid extends React.Component<AffilationsGridProps, AffilationsGridState>{
    private id: string;
    private gridOptions: kendo.ui.GridOptions;
    private dataSource: { Value: any; Text: any; }[] = [];
    private buttonIds = {
        add: "add",
        remove: "remove",
        changeDefaultState: "changeDefaultState"
    };
    private showDefault: boolean = true;

    constructor(props: AffilationsGridProps) {
        super(props);
        this.state = {
            selected: [],
            dialogOpen: false
        };
        this.initApp();
    }

    private setValue = (affilations: Affilation[]) => {
        this.props.onChange(this.props.field, affilations);
    }

    private initApp = async () => {
        this.id = kendo.guid();
        const dataSource = await HTTPService.get<any[]>(this.props.field.url);
        this.dataSource = dataSource.map((item) => {
            return {
                Value: item[this.props.field.dataValueField],
                Text: item[this.props.field.dataTextField],
            }
        }).sort((a, b) => {
            if (a.Text < b.Text)
                return -1;
            if (a.Text > b.Text)
                return 1;
            return 0;
        });
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: "multiple, row",
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Value",
                    title: this.props.field.label,
                    template: (data: Affilation) => {
                        return this.getField(data.EntityId);
                    }
                }
            ]
        };

        if (Helper.hasValue(this.props.field.showDefault)) {
            this.showDefault = this.props.field.showDefault;
        }

        if (this.showDefault) {
            this.gridOptions.columns.push({
                field: "IsDefault",
                title: Helper.getTranslation("Standard.Default"),
                template: (data: Affilation) => {
                    return `<div class='grid-icon-custom-center' style='color:${data.IsDefault ? "green" : "red"}'><i class='fal fa-${data.IsDefault ? "check" : "times"}'></i></div>`
                }
            });
        }
        this.setState({});
    }

    private getField = (entityId: string | number) => {
        const item = this.dataSource.find(f => f.Value === entityId);
        return Helper.hasValue(item) ? item.Text : entityId;
    }

    private createToolBar = () => {
        const setAllToDefault = Helper.hasValue(this.state.selected) && Array.isArray(this.state.selected) && (this.state.selected.filter(f => !f.IsDefault).length > 0);
        const customButtons = [
            { caption: Config.translations.add, enabled: true, iconClass: "k-i-plus", id: this.buttonIds.add },
            { caption: Config.translations.delete, enabled: Helper.hasValue(this.state.selected) && this.state.selected.length > 0, iconClass: "k-i-close", id: this.buttonIds.remove }
            
        ];
        if (this.showDefault) {
            customButtons.push({
                caption: setAllToDefault ? Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.UseAsDefault") : Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Favorite.DontUseAsDefault"),
                enabled: Helper.hasValue(this.state.selected) && this.state.selected.length > 0,
                iconClass: setAllToDefault ? "k-i-check" : "k-i-close",
                id: this.buttonIds.changeDefaultState
            });
        }

        return (
            <>
                <ToolBar customButtons={customButtons} handleCustomButtonClick={this.handleClickCustomButton} />
            </>
        );
    }

    private filterValue = ({ EntityId }: Affilation) => {
        const index = this.dataSource.findIndex(({ Value }) => Value === EntityId);
        return index !== -1;
    }

    private sortValue = (a: Affilation, b: Affilation) => {
        const aff_a = this.dataSource.find(aff => aff.Value == a.EntityId);
        const aff_b = this.dataSource.find(aff => aff.Value == b.EntityId);

        if (aff_a.Text < aff_b.Text)
            return -1;
        if (aff_a.Text > aff_b.Text)
            return 1;
        return 0;
    }

    private renderGrid = () => {
        if (!Helper.hasValue(this.gridOptions)) {
            return null;
        }
        const griddata = this.props.value.filter(this.filterValue).sort(this.sortValue)
        return (
            <div className="flex-container">
                <Grid
                    data={griddata}
                    options={this.gridOptions}
                    id={this.id}
                    onSelectionChanged={this.onSelctionChange}
                />
            </div>
        );
    }

    private onSelctionChange = (dataItem: Affilation | Affilation[]) => {
        if (Helper.hasValue(dataItem)) {
            if (Array.isArray(dataItem)) {
                this.setState({ selected: dataItem })
            } else {
                this.setState({ selected: [dataItem] })
            }

        }
    }

    private handleClickCustomButton = (id: string) => {
        switch (id) {
            case this.buttonIds.add:
                this.setState({ dialogOpen: true, selected: null })
                break;
            case this.buttonIds.remove:
                const affilations = JSON.parse(JSON.stringify(this.props.value)).filter((val) => this.state.selected.find(f => f.Id == val.Id) == null);
                this.setState({ selected: [] }, () => {
                    this.setValue(affilations);
                });
                break;
            case this.buttonIds.changeDefaultState:
                this.changeDefaultState();
                break;
        }
    }

    private changeDefaultState = () => {
        const affilations = JSON.parse(JSON.stringify(this.props.value));
        const setAllToDefault = Helper.hasValue(this.state.selected) && Array.isArray(this.state.selected) && (this.state.selected.filter(f => !f.IsDefault).length > 0);
        for (let i = 0; i < affilations.length; i++) {
            const index = this.state.selected.findIndex(f => f.Id == affilations[i].Id);
            if (index > -1) {
                affilations[i].IsDefault = setAllToDefault;
            }
        }
        this.setState({ selected: [] }, () => {
            this.setValue(affilations);
        });
    }

    private renderReplacementText = () => {
        return (
            <div style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1" }}>
                    <i className={`${this.props.field.icon} fa-10x`} style={{ opacity: 0.1 }}></i>
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "40px" }}>
                    <label style={{ fontSize: "15px" }}>
                        {this.props.field.replacementText}
                    </label>
                </div>
            </div>
        );
    }

    private renderDialog = () => {
        return (
            <>
                <AffilationsDialog
                    dataSource={this.dataSource.filter(item => this.props.value.find(f => f.EntityId == item.Value) == null)}
                    label={this.props.field.label}
                    onClose={() => { this.setState({ dialogOpen: false }) }}
                    onOk={(ids) => {
                        const data = this.props.value;
                        ids.forEach((id) => {
                            data.push({
                                EntityId: id,
                                Id: kendo.guid(),
                                IsDefault: false
                            })
                        })
                        this.setValue(data);
                        this.setState({ dialogOpen: false })
                    }}
                />
            </>
        );
    }

    render() {
        
        const dialog = this.state.dialogOpen ? this.renderDialog() : null;
        const grid = (this.props.value.length > 0) ? this.renderGrid() : this.renderReplacementText();
        const toolBar = this.createToolBar();
        return (
            <div id={this.id}>
                {toolBar}
                {grid}
                {dialog}
            </div>
        );
    }
}

interface AffilationsGridProps {
    value: Affilation[];
    onChange: (field, value) => void;
    field: {
        url: string,
        replacementText: string,
        icon: string,
        dataValueField: string,
        dataTextField: string,
        label: string,
        showDefault: boolean
    }
} 

interface AffilationsGridState {
    selected: Affilation[];
    dialogOpen: boolean;
}

interface Affilation {
    Id: string;
    EntityId: number | string;
    IsDefault: boolean;
}

class AffilationsDialog extends React.Component<AffilationsDialogProps, AffilatonsDialogState>{

    constructor(props: AffilationsDialogProps) {
        super(props)

        this.state = {
            values: []
        }
    }

    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: this.props.label,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.setState({ values: [] }, this.props.onClose);
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    const data = this.state.values.map((val) => {
                        return val.Value;
                    });
                    this.props.onOk(data);
                },
                primary: true
            }
        ],
        width: 500
    };


    render() {
        const props = this.factory.getDefaultMultiSelectProps();
        props.dataSource = this.props.dataSource;
        props.field.dataTextField = "Text";
        props.field.dataValueField = "Value";
        props.value = this.state.values;
        props.onChange = (_, values) => {
            this.setState({ values: values })
        }

        return (
            <>
                <Dialog {...this.dialogProps} open={true}>
                    <MultiSelect {...props} />
                </Dialog>
            </>
        );
    }
}

interface AffilationsDialogProps {
    dataSource: any[];
    label: string;
    onClose: () => void;
    onOk: (ids: number[]) => void;
}

interface AffilatonsDialogState {
    values: any[];
}